import { render, staticRenderFns } from "./modalEditRbacAccess.vue?vue&type=template&id=25d705a4&"
import script from "./modalEditRbacAccess.vue?vue&type=script&lang=js&"
export * from "./modalEditRbacAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports